var _excluded = ["label"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { StyledTag } from './StyledTag';
function Tag(_ref) {
  var label = _ref.label,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledTag, rest, label);
}
Tag.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Defines the color of component
   */
  color: PropTypes.oneOf(['default', 'primary', 'primaryAlt', 'secondary', 'secondaryAlt', 'tertiary', 'error', 'warning', 'success', 'info']),
  /**
   *
   */
  colorShade: PropTypes.string,
  /**
   *  Defines the shape of component edges
   */
  edges: PropTypes.oneOf(['default', 'rounded', 'sharp', 'smooth']),
  /**
   * Text to display in component
   */
  label: PropTypes.string.isRequired,
  /**
   * Size of the component
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['outlined', 'solid'])
} : {};
Tag.defaultProps = {
  color: 'secondaryAlt',
  colorShade: 'main',
  edges: 'default',
  size: 'medium',
  variant: 'solid'
};
export default Tag;